import { useState } from 'react';
import styles from '../buildCard.module.sass';
import { Button } from 'react-bootstrap';

interface ReadMoreProps {
    text: string;
    expanded: boolean;
}

export const RenderBasedOnWordCount = (props: ReadMoreProps) => {

    const [isCollapsed, setIsCollapsed] = useState(true);

    const wordCountToDisplay = 16;

    const textArray = props.text.split(' ');

    const itCanOverflow = textArray.length > wordCountToDisplay;

    const beginText = itCanOverflow
        ? textArray.slice(0, wordCountToDisplay - 1).join(' ')
        : props.text;

    const endText = textArray.slice(wordCountToDisplay - 1).join(' ');

    return (
        <div className={styles.cardContent}>
            {beginText}
            {itCanOverflow && (
                <>
                    {isCollapsed && <span>... </span>}
                    <span
                        className={`${isCollapsed && 'hidden'}`}
                    > {endText}</span>
                    <Button
                        variant="link"
                        className={styles.collapseToggleButton}
                        tabIndex={0}
                        onClick={() => setIsCollapsed(!isCollapsed)}
                    >{isCollapsed ? 'Show more' : 'Show less'}</Button>
                </>
            )}
        </div>
    );
};
